export default __webpack_public_path__ + "static/media/patient-assigned.aaeed322.png";